module.exports = __webpack_public_path__ + "static/media/anyone-freelancer.5accad5f.jpg";